angular.module('unergie.main')
.controller('invoicesV2Ctrl', ($scope, $filter, $window, $state, $uibModal, b2g, DataAccess, NgTableParams, PaymentService, BoFeaturesService, FilterMapping, Sequentializer,
    DataAccessSearch, DownloadService, ApiCons, MS, ApiBilling, ModalService, AlertManager, TableGeneratorService, ErrorCatcher) => {
    $scope.b2g = b2g
    $scope.isActive = (state) => $state.is(state)
    $scope.invoiceStatuses = FilterMapping.invoiceStatuses
    $scope.invoiceTypes = FilterMapping.invoiceTypes
    $scope.billingAdmin = BoFeaturesService.isFeatureOn('billingAdmin')

    const invoicesFeat = BoFeaturesService.getModuleFeatures('invoices')

    $scope.boolFilter = [{ id: true, title: 'Oui' }, { id: false, title: 'Non' }]

    $scope.canRunInvoices = BoFeaturesService.isFeatureOn('canRunInvoices')

    $scope.paymentValidated = (payment) => !PaymentService.paymentNotYetValidated(payment)

    const fetchUnaffectedFeesCount = () => {
        return DataAccessSearch()
        .count({ resource: 'fees', status: 'UNAFFECTED' }).$promise.then((unaffectedFeesCountResult) => {
            $scope.unaffectedFeesCount = unaffectedFeesCountResult.count
        })
    }

    const ALERT_RATIO = 1.8
    const WARNING_RATIO = 1.2
    const POT_RATIO = 0.85

    $scope.computeRatio = (ratio) => {
        if (Number(ratio) > ALERT_RATIO) {
            return { alert: true, class: 'ratio-alert', message: 'La consommation réelle est largement au dessus de la consommation estimée, régularisation importante !' }
        }
        if (Number(ratio) > WARNING_RATIO) {
            return { alert: false, class: 'ratio-warning', message: 'La consommation réelle est au dessus de la consommation estimée, régularisation importante' }
        }
        if (Number(ratio) < POT_RATIO) {
            return { alert: false, class: 'ratio-pot', message: 'La consommation réelle est au dessous de la consommation estimée, cagnotte importante' }
        }
        return { alert: false, class: 'ratio-ok', message: `La consommation réelle est en phase avec l'estimation` }
    }

    const fieldsToHide = invoicesFeat.hideFields
    if (b2g) {
        fieldsToHide.push('contractElec.account.fullname')
        fieldsToHide.push('due_date')
        fieldsToHide.push('payments.amount')
        fieldsToHide.push('billshock')
        fieldsToHide.push('cagnotte')
        fieldsToHide.push('cagnotte_earned')
    } else {
        fieldsToHide.push('contractElec.category.name')
        fieldsToHide.push('contractElec.account.brand')
        fieldsToHide.push('contractElec.category.organization')
    }

    $scope.invoices = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: _.omit({
            'selector': { label: 'Sel.', mode: 'filter_only' },
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'download_link': { label: 'PDF', mode: 'search_wildcard' },
            'id_contract': { label: 'Contrat', mode: 'search_wildcard', mandatory: true },
            'contractElec.account.fullname': { label: 'Client', mode: 'search_wildcard' },
            'invoice_number': { label: 'N° Facture', mode: 'search_wildcard' },
            'status': { label: 'Status', mode: 'search_operator', mandatory: true },
            'type': { label: 'Type', mode: 'search_operator', mandatory: true },
            'invoice_date': { label: 'Date Facture', mode: 'search_date' },
            'period_start_date': { label: 'Début', mode: 'search_date' },
            'period_end_date': { label: 'Fin', mode: 'search_date' },
            'due_date': { label: 'Due date', mode: 'search_date' },
            'total': { label: 'Total', mode: 'filter_only' },
            'consommation': { label: 'Consommation', mode: 'filter_only' },
            'abonnement': { label: 'Abonnement', mode: 'filter_only' },
            'taxe': { label: 'Taxe', mode: 'filter_only' },
            'cagnotte': { label: 'Cagnotte', mode: 'filter_only' },
            'cagnotte_earned': { label: 'Cagnotte gagnée', mode: 'filter_only' },
            'tva': { label: 'TVA', mode: 'filter_only' },
            'payments.amount': { label: 'Paiement', mode: 'search_operator' },
            'preparation_result': { label: 'Résultats intermédiaires', mode: 'hidden' },
            'reading_ids': { label: 'Relèves', mode: 'hidden' },
            'reversal_of': { label: 'Facture reversée', mode: 'hidden' },
            'error_code': { label: 'Code erreur', mode: 'hidden' },
            'version': { label: 'Code erreur', mode: 'hidden' },
            'billshock': { label: 'BillShock', mode: 'filter_only' },
            'contractElec.category.name': { label: 'Paquet facturier', mode: 'search_wildcard' },
            'contractElec.category.organization': { label: 'Org.', mode: 'search_wildcard' },
            'contractElec.account.brand': { label: 'Compte', mode: 'search_wildcard' },
            "billing_context#>'force_landscape_loading'": { mode: 'hidden', translate: 'forceLandscapeLoading' },
        }, fieldsToHide),
    }


    $scope.isMisc = (i) => i.type.indexOf('MISC') > -1
    $scope.isReversal = (invoice) => invoice.type.indexOf('_REVERSAL') > -1
    $scope.doneable = (invoice) => [11, 20, 21, 30].includes(invoice.status)
    $scope.inProcessable = (invoice) => [11, 20, 21].includes(invoice.status)
    $scope.simulable = (invoice) => ([40, 500, 501, 502, 90, 92, 93, 99].includes(invoice.status)
    || (invoice.type !== 'REG' && [11].includes(invoice.status))) && !$scope.isReversal(invoice)
    $scope.ttSimulable = (invoice) => [11, 40, 500, 501, 502, 90, 92, 93, 94, 95, 99].includes(invoice.status) && !$scope.isReversal(invoice) && invoice.type === 'REG'
    $scope.cancellable = (invoice) => [0, 1, 11, 12, 20, 21, 30, 40, 500, 501, 502, 90, 91, 92, 94, 95, 99].includes(invoice.status) && !$scope.isReversal(invoice)
    $scope.valuable = (invoice) => [0, 11, 12, 20, 21, 40, 500, 501, 502, 90, 91, 92, 93, 94, 95, 99].includes(invoice.status) && !$scope.isReversal(invoice) && invoice.type !== 'MISC'
    $scope.mergeable = (invoice) => [0, 11, 12, 20, 21, 40, 500, 501, 502, 90, 91, 92, 93, 94, 95, 99].includes(invoice.status) && !$scope.isReversal(invoice) && invoice.type !== 'MISC'
    $scope.extendable = (invoice) => [0, 11, 12, 20, 21, 40, 500, 501, 502, 90, 91, 92, 93, 94, 95, 99].includes(invoice.status) && !$scope.isReversal(invoice) && invoice.type !== 'MISC'
    $scope.flagValuable = (invoice) => [1, 12, 20, 21].includes(invoice.status) && !$scope.isReversal(invoice) && invoice.type !== 'MISC'
    $scope.holdable = (invoice) => [11, 12, 20, 21, 30, 92, 93, 99].includes(invoice.status) && !$scope.isReversal(invoice) && invoice.type !== 'MISC'
    $scope.reversable = (invoice) => [50, 54, 55, 93, 96].includes(invoice.status) && !$scope.isReversal(invoice)
    $scope.runnable = (invoice) => [31, 54, 93, 96].includes(invoice.status) || (invoice.type !== 'REG' && [501, 502].includes(invoice.status))
    $scope.ttRunable = (invoice) => [54, 501, 502, 93, 96].includes(invoice.status) && invoice.type === 'REG'
    $scope.regenable = (invoice) => [54, 50, 55, 96].includes(invoice.status)
    $scope.sent = (invoice) => [50, 55].includes(invoice.status)
    $scope.canForceLandscapeLoading = (invoice) => (invoice.status === 94) // uniquement ce statut
    $scope.processing = (invoice) => _.some([
        $scope.massOperating,
        invoice.simulating,
        invoice.valuating,
        invoice.running,
        invoice.reversing,
        invoice.cancelling,
        invoice.flagValuating,
        invoice.doning,
        invoice.extending,
        invoice.merging,
        invoice.holding,
        invoice.inProcessing,
        invoice.doneing,
        invoice.simulatingTt,
        invoice.generatingTt,
    ])
    $scope.simulateTimetableFields = {
        forceLandscapeLoading: {
            label: 'forcer le chargement du paysage',
            type: 'checkbox',
        },
    }

    $scope.toggleSelected = function (invoice, e) {
        e.preventDefault()
        e.stopPropagation()
        invoice.selected = !invoice.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.invoices.instance.data, (c) => {
            c.selected = true
        })


    $scope.deSelectAll = () =>
        _.forEach($scope.invoices.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getValuables = () =>
        _.filter($scope.invoices.instance.data, (i) => i.selected && $scope.valuable(i))

    $scope.getSimulables = () =>
        _.filter($scope.invoices.instance.data, (i) => i.selected && $scope.simulable(i))

    $scope.getRunnables = () =>
        _.filter($scope.invoices.instance.data, (i) => i.selected && $scope.runnable(i))

    $scope.getTtSimulable = () => _.filter($scope.invoices.instance.data, (i) => i.selected && $scope.ttSimulable(i))

    $scope.getTtRunable = () => _.filter($scope.invoices.instance.data, (i) => i.selected && $scope.ttRunable(i))

    $scope.getSelectedNumber = () => _.countBy($scope.invoices.instance.data, 'selected').true || 0


    $scope.mass = (operation) => {
        if ($scope.massOperating) {
            return
        }
        let toOperate
        switch (operation) {
            case 'valuate': toOperate = _.map($scope.getValuables(), 'id')
                break
            case 'simulation': toOperate = _.map($scope.getSimulables(), 'id')
                break
            case 'run': toOperate = _.map($scope.getRunnables(), 'id')
                break
            default: AlertManager.error('Operation inconnue')
        }
        $scope.massOperating = true
        $scope[`mass${operation}`] = true
        return ApiBilling.massOperation({ operation }, toOperate).$promise.then((result) => {
            AlertManager.success(`Batch '${operation}' traité avec succès`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massOperating = false
            $scope[`mass${operation}`] = false
            $scope.refreshInvoices()
        })
    }

    $scope.massProcessTimeTables = (simu) => {
        if ($scope.massOperating) {
            return
        }
        const invoices = simu ? $scope.getTtSimulable() : $scope.getTtRunable()
        if (!invoices.length) {
            return
        }
        $scope[`mass${simu ? 'TtSimulating' : 'TtRunning'}`] = true
        return Sequentializer.mapSeries(invoices, (invoice) => (simu ? $scope.simulateTimetable(invoice, null, true) : $scope.regenTimetable(invoice, null, true)))
        .then((result) => {
            console.log(`massProcessTimeTables simu=${simu} result`, result)
            AlertManager.success(`Échéancier ${simu ? 'simulés' : 'générés'}`)
        })
        .finally(() => {
            $scope[`mass${simu ? 'TtSimulating' : 'TtRunning'}`] = false
            $scope.refreshInvoices()
        })
    }

    const calculateDetails = (i) => {
        const details = $scope.isReversal(i) ? i.reversed['invoice-details'] : i['invoice-details']
        _.assign(i, {
            details: {
                consDetailsCollapsed: true,
                consDetails: new NgTableParams({ count: 12 }, {
                    counts: [],
                    dataset: _.filter(details, { category: 'consommation', type: 'detail' }),
                }),
                aboDetailsCollapsed: true,
                aboDetails: new NgTableParams({ count: 12 }, {
                    counts: [],
                    dataset: _.filter(details, { category: 'abonnement', type: 'detail' }),
                }),
                taxDetailsCollapsed: true,
                taxDetails: new NgTableParams({ count: 12 }, {
                    counts: [],
                    dataset: _.filter(details, { category: 'taxe', type: 'stotal' }),
                }),
            },
        })
    }

    $scope.refreshInvoice = function (i) {
        const refreshes = []
        if (!$scope.isMisc(i)) {
            refreshes.push($scope.refreshInvoiceReadings(i))
            calculateDetails(i)
        } else {
            refreshes.push($scope.refreshInvoiceFees(i))
        }
        i.refreshing = true
        return Promise.all(refreshes).then(() => {
            i.fetched = true
            i.refreshing = false
        })
    }

    $scope.toggleExpand = function (invoice) {
        if (!invoice.refreshing) {
            invoice.expanded = !invoice.expanded
            if (!invoice.fetched) {
                $scope.refreshInvoice(invoice)
            }
        }
    }

    // TEST READINGS
    $scope.contractPayload = {
        ids_contract: '',
    }

    $scope.contractFields = {
        ids_contract: {
            label: 'IDS Contrat',
            placeholder: 'id_contrat_1,id_contrat_2...',
            type: 'text',
        },
    }

    // CALLS
    $scope.refreshInvoiceReadings = (invoice) => {
        if (!invoice.reading_ids) {
            return
        }
        return DataAccessSearch({ in: [`id=${invoice.reading_ids.ids.join(',')}`], orderBy: '-end_date' })
        .searchPaginated({ resource: 'readings' }).$promise.then((readingsResult) => {
            let readings = _.filter(_.orderBy(readingsResult.results, '-end_date'), (r) => r.start_date !== null)
            _.each(readings, (r) => {
                r.cons = r.consumption || r.value - (r.last_value || 0)
                r.dates = `${moment(r.start_date).format('DD/MM/YYYY')} ⮕ ${moment(r.end_date).format('DD/MM/YYYY')}`
            })
            readings = _.groupBy(readings, (r) => r.dates + r.index_nature)
            readings = _.map(readings, (v) => {
                const days = moment(v[0].end_date).diff(moment(v[0].start_date), 'days')
                const cons = _.sumBy(v, 'cons')
                return {
                    index_nature: v[0].index_nature,
                    dates: v[0].dates,
                    days,
                    index: _.sumBy(v, (e) => `${e.temp_class} : ${e.last_value} ⮕ ${e.value} `),
                    cons,
                    consDaily: (cons / days).toFixed(2),
                    detailsCons: (v.length > 1 ? `(${_.sumBy(v, (e) => `${e.temp_class} : ${e.cons} `)})` : ''),
                }
            })
            invoice.readingsTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: readings,
            })
        }).catch(ErrorCatcher)
    }

    $scope.refreshInvoiceFees = (invoice) => {
        const i = invoice.reversed || invoice
        if ((i.fees && i.fees.length) || !i.preparation_result || !i.preparation_result.id_fees || !i.preparation_result.id_fees.length) {
            return
        }
        const feesId = i.preparation_result.id_fees
        return DataAccessSearch({ in: [`id=${feesId.join(',')}`] }).searchPaginated({ resource: 'fees' }).$promise.then((fees) => {
            invoice.fees = fees.results
        })
        .catch(ErrorCatcher)
    }

    $scope.verifyReadingsForInvoice = () => {
        $scope.checkingReadings = true
        let promise
        if ($scope.contractPayload.ids_contract) {
            promise = ApiBilling.contractsCheckReadings({}, { contract_ids: $scope.contractPayload.ids_contract.split(',') })
        } else {
            promise = ApiBilling.checkReadings({})
        }
        return promise.$promise.then((result) => {
            if ($scope.contractPayload.ids_contract) {
                const invoices = _.compact(_.map(result, 'invoice')).join(',')
                if (invoices) {
                    AlertManager.success(`Facture à processer \nid: ${invoices} \n${result.message}`)
                } else {
                    AlertManager.success('Pas de Facture à traiter')
                }
                _.filter(result, { status: 'ko' }).forEach((e) => {
                    AlertManager.error(e.message, 5000)
                })
            } else if (result.length > 0) {
                ModalService.openModal(
                    { type: 'resultModal', size: 'lg' },
                    { result: { processed: result.length, newInvoices: _.filter(result, 'invoice'), errors: _.filter(result, { status: 'ko' }) } }
                )
            } else {
                AlertManager.success('Pas de Facture à traiter')
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshInvoices()
            $scope.checkingReadings = false
        })
    }

    $scope.extend = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.extendable(invoice)) {
            invoice.extending = true
            return ApiBilling.extendInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
                AlertManager.success(`Extension OK : ${result.message}`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.extending = false
                $scope.refreshInvoices()
            })
        }
    }

    $scope.merge = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.mergeable(invoice)) {
            invoice.merging = true
            return ApiBilling.mergeInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
                AlertManager.success(`Merge OK : ${result.message}`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.merging = false
                $scope.refreshInvoices()
            })
        }
    }

    $scope.simulate = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.simulable(invoice)) {
            invoice.simulating = true
            return ApiBilling.prepareInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
                const status = result.toJSON().status
                if (status === 501) {
                    AlertManager.success('Simulation OK !')
                } else {
                    AlertManager.error('Simulation KO !')
                }
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.simulating = false
                $scope.refreshInvoices()
            })
        }
    }

    $scope.valuate = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.valuable(invoice)) {
            invoice.valuating = true
            return ApiBilling.valuateInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
                AlertManager.success(`Valorisation OK : ${result.message}`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.valuating = false
                $scope.refreshInvoices()
            })
        }
    }

    $scope.simulateTimetable = (invoice, e, skipRefresh) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        if ($scope.processing(invoice)) {
            return Promise.resolve()
        }

        invoice.simulatingTt = true
        const forceLandscapeLoading = $scope.canForceLandscapeLoading(invoice) ? invoice.forceLandscapeLoading : undefined
        return ApiBilling.simulateTimetable({ id_invoice: invoice.id, forceLandscapeLoading }, {}).$promise.then((result) => {
            AlertManager.success('Simu tt OK')
            return result
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.simulatingTt = false
            if (!skipRefresh) {
                $scope.refreshInvoices()
            }
        })
    }

    $scope.run = (invoice, regen) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.running = true
        return ApiBilling.runInvoice({ id_invoice: invoice.id, send: !regen, regen: !!regen }, {}).$promise.then((result) => {
            AlertManager.success('Lancement OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.running = false
            $scope.refreshInvoices()
        })
    }

    $scope.regenTimetable = (invoice, e, skipRefresh) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        if ($scope.processing(invoice)) {
            return Promise.resolve()
        }
        invoice.generatingTt = true
        return ApiBilling.regenTimetable({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Regen tt OK')
            return result
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.generatingTt = false
            if (!skipRefresh) {
                $scope.refreshInvoices()
            }
        })
    }

    $scope.reverseInvoice = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.reversing = true
        return ApiBilling.reverseInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Reversement OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.reversing = false
            $scope.refreshInvoices()
        })
    }

    $scope.cancelInvoice = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.cancelling = true
        return DataAccess.cancelInvoiceV2({ id_invoice: invoice.id }).$promise.then((result) => {
            AlertManager.success('Annulation OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.cancelling = false
            $scope.refreshInvoices()
        })
    }

    // BUDGET
    $scope.flagValuatedFields = {
        consumption_manually_checked: {
            type: 'label',
            label: '<span class="dark-pink fs-600">Avez vous bien vérifié la consommation<br/>sur la période de facturation ?</span>',
        },
    }
    $scope.flagValuated = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.flagValuable(invoice)) {
            invoice.flagValuating = true
            return DataAccess.setInvoiceV2Valuated({ id_invoice: invoice.id }, {}).$promise.then((result) => {
                AlertManager.success('Valorisation OK')
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.flagValuating = false
                $scope.refreshInvoices()
            })
        }
    }
    $scope.hold = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.holding = true
        return DataAccess.setInvoiceOnHold({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Mise de coté OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.holding = false
            $scope.refreshInvoices()
        })
    }

    $scope.setDone = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.doneing = true
        return DataAccess.setInvoiceV2Done({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Facturée OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.doneing = false
            $scope.refreshInvoices()
        })
    }

    $scope.setProcessing = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.inProcessing = true
        return DataAccess.setInvoiceV2Processing({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Facturée mise en traitement')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.inProcessing = false
            $scope.refreshInvoices()
        })
    }

    // DL LINK
    $scope.dlInvoice = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        return DownloadService.downloadInvoice(invoice.download_link, invoice.contractElec.id_account)
    }

    // TABLE
    const transform = (invoices) => {
        _.each(invoices, (invoice) => {
            invoice.contractElec.account.fullname = `${invoice.contractElec.account.givenname} ${invoice.contractElec.account.sn}`
            invoice.readingCollapsed = true
            invoice.estiCollapsed = true
            if ($scope.isReversal(invoice)) {
                const details = invoice.reversed['invoice-details']
                _.assign(invoice, {
                    consommation: -MS.round(_.sumBy(_.filter(details, { category: 'consommation', type: 'stotal' }), 'amount')),
                    abonnement: -MS.round(_.sumBy(_.filter(details, { category: 'abonnement', type: 'stotal' }), 'amount')),
                    taxe: -MS.round(_.sumBy(_.filter(details, { category: 'taxe', type: 'stotal' }), 'amount')),
                    cagnotte: -MS.round(_.sumBy(_.filter(details, { category: 'cagnotte', type: 'stotal' }), 'amount')),
                    tva: -MS.round(_.sumBy(_.filter(details, { category: 'tva', type: 'stotal' }), 'vat_amount')),
                    total: -MS.round(_.sumBy(_.filter(details, { category: 'total', type: 'total' }), 'total')),
                })
            } else {
                const details = invoice['invoice-details']
                _.assign(invoice, {
                    consommation: MS.round(_.sumBy(_.filter(details, { category: 'consommation', type: 'stotal' }), 'amount')),
                    abonnement: MS.round(_.sumBy(_.filter(details, { category: 'abonnement', type: 'stotal' }), 'amount')),
                    taxe: MS.round(_.sumBy(_.filter(details, { category: 'taxe', type: 'stotal' }), 'amount')),
                    cagnotte: MS.round(_.sumBy(_.filter(details, { category: 'cagnotte', type: 'stotal' }), 'amount')),
                    tva: MS.round(_.sumBy(_.filter(details, { category: 'tva', type: 'stotal' }), 'vat_amount')),
                    total: MS.round(_.sumBy(_.filter(details, { category: 'total', type: 'total' }), 'total')),
                })
            }
            // get payment for prepared invoices
            const amount = invoice.preparation_result && invoice.preparation_result.sumup &&
            (invoice.preparation_result.sumup.finalPayment !== undefined ? invoice.preparation_result.sumup.finalPayment : invoice.preparation_result.sumup.paymentDue)
            if (!invoice.payments && invoice.status === 501 && amount) {
                invoice.payments = {
                    amount,
                }
            }
        })
    }

    const activate = () => {
        TableGeneratorService.getTable(
            $scope.invoices,
            'invoices-v2',
            `invoice-details,contractElec.account,payments,reversed.invoice-details,fees${b2g ? ',contractElec.category' : ''}`,
            transform,
            {
                orderBy: '-id',
                notnull: b2g ? ['contractElec.account.organization'] : [],
            },
        )
        fetchUnaffectedFeesCount()
    }

    $scope.openFeeModal = () => {
        ModalService.openModal({ type: 'feesCheckModal', size: 'lg', backdrop: 'static' }, {}, $scope.refreshInvoices)
    }

    $scope.openFeeAffectationModal = () => {
        ModalService.openModal({ type: 'feesAffectationModal', size: 'lg', backdrop: 'static' }, {}, () => {
            fetchUnaffectedFeesCount()
            $scope.refreshInvoices()
        })
    }

    $scope.refreshInvoices = activate
    activate()

    $scope.getNbMessages = () => {
        ApiBilling.getMessagesNumber().$promise.then((result) => {
            $scope.nbMessages = result
        })
        .catch(ErrorCatcher)
    }
    $scope.getNbMessages()
})
